import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define the state interface
export interface ListLoaderState {
  listIndex: number;
}

const initialState: ListLoaderState = {
  listIndex: 50  // Initial value for listIndex, assuming 50 is the default
};

export const listLoaderSlice = createSlice({
  name: 'listLoader',
  initialState,
  reducers: {
    // Accept a function that calculates the new state based on previous state
    setListLoader: (state, action: PayloadAction<number | ((prev: number) => number)>) => {
      if (typeof action.payload === 'function') {
        state.listIndex = action.payload(state.listIndex);
      } else {
        state.listIndex = action.payload;
      }
    }
  }
});

export const { setListLoader } = listLoaderSlice.actions;
export default listLoaderSlice.reducer;
